import request from '../../../helpers/request';

const deleteRoomOwner = async (ownerId, room) => {
  await request.put(
    `/RentPlace/rental_house/office`,
    {
      ...room,
      landLords: room.landLords.filter((landLord) => landLord.id !== ownerId)
    },
    'При удалении собственника произошла ошибка'
  );
};

export default deleteRoomOwner;
